/**
 * sk-room-pax
 * used to create the pax configuration widget inthe room details screen
 */
var skPaxDisabled = 'pax-disabled';
var skPaxFocused = 'active';

bookingApp.directive('skRoomPax',function(){
    return {
        template: '' +
        '<div class="paxing-group" ng-init="paxCheckPassed">' +
            '<div class="pax-selectors all-pax-required"' +
                'ng-init="adultsLabel = (2|paxLabel:\'adult\'); childrenLabel = (2|paxLabel:\'child\'); infantsLabel = (2|paxLabel:\'infant\');"' +
                'ng-class="{\'long-labels\':(adultsLabel.length > 8 || childrenLabel.length > 8 || infantsLabel.length > 8)}"' +
                    '>' +
                '<div class="pax-group adults">' +
                    '<label ng-bind="adultsLabel"></label>' +
                    '<select ng-model="session.selectedRoom.selectedAdults">' +
                        '<option ng-repeat="n in getOptionArray(\'adults\') track by $index" value="{{$index}}" ng-selected="$index === session.selectedRoom.selectedAdults">{{$index}}</option>' +
                    '</select>' +
                '</div>' +
                '<div class="pax-group children">' +
                    '<label ng-bind="childrenLabel"></label>' +
                    '<select ng-model="session.selectedRoom.selectedChildren">' +
                        '<option ng-repeat="n in getOptionArray(\'children\') track by $index" value="{{$index}}" ng-selected="$index===session.selectedRoom.selectedChildren">{{$index}}</option>' +
                    '</select>' +
                '</div>' +
                '<div class="pax-group infants">' +
                    '<label ng-bind="infantsLabel"></label>' +
                    '<select ng-model="session.selectedRoom.selectedInfants">' +
                        '<option ng-repeat="n in getOptionArray(\'infants\') track by $index" value="{{$index}}" ng-selected="$index===session.selectedRoom.selectedInfants">{{$index}}</option>' +
                    '</select>' +
                '</div>' +
            '</div>' +
            '<div class="edit-controls">' +
                '<div class="col-xs-6 control remove">' +
                    '<button class="btn btn-danger col-xs-12" ng-click="removeRoomBackToCart()">Remove {{"Room" | marketingGroup : \'single\' : session.selectedRoom.roomDetails.marketingGroup}} <span class="glyphicon glyphicon-remove"></span></button>' +
                '</div>' +
                '<div class="col-xs-6 control remove">' +
                    '<button class="btn btn-primary col-xs-12" ng-click="paxCheckPassed = updateRoom()">Update <span class="glyphicon glyphicon-ok"></span></button>' +
                '</div>' +
            '</div>' +
            '<div class="row">' +
                '<div class="add-room-to-cart container">' +
                    '<button class="btn btn-primary col-xs-12" ng-click="paxCheckPassed = addRoomToCart()">Add to Cart</button>' +
                '</div>' +
            '</div>' +
            '<div class="row">' +
                '<div class="pax-error text-center container" ng-show="paxCheckPassed === false">' +
                    'Minimum number of guests not reached' +
                '</div>' +
            '</div>'+
        '</div>' +
        '',
        link: function(scope, element, attrs, controller){
            if(attrs.editingRoom){
                element.find('.edit-controls').show();
                element.find('.add-room-to-cart').hide();
            } else {
                element.find('.edit-controls').hide();
                element.find('.add-room-to-cart').show();
            }
            // get the selected room
            var selectedRoom = scope.property.rooms[scope.session.viewingRoom];
            var validForInfants = selectedRoom.rate.isValidForInfants;
            var validForChildren = selectedRoom.rate.isValidForChildren;
            var basePax = selectedRoom.rate.basePax;
            var maxAdditionalPax = selectedRoom.rate.maxAdditionalPax;
            var maxPax = selectedRoom = basePax + maxAdditionalPax;

            // check children are valid in rate - hide if not
            if(!validForChildren){
                element.find('.children').hide();
                element.find('.pax-selectors').removeClass('all-pax-required');
            }
            if(!validForInfants){
                element.find('.infants').hide();
                element.find('.pax-selectors').removeClass('all-pax-required');
            }

            // setup the event handlers
            element.find('select').on('focus',function(){
                $(this).parent().addClass(skPaxFocused);
            });
            element.find('select').on('blur', function(){
                $(this).parent().removeClass(skPaxFocused);
            });
        }
    }
});
